import * as React from 'react'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button, InfoSheet } from '@components'
import i18n from '@core/translations'
import type { UserFallbackState } from './UserFallback.types'
import { getUserStatusContent } from './UserFallback.utils'

const UserFallback: React.FC = () => {
    const { t } = useTranslation()
    const state = useLocation().state as UserFallbackState | undefined

    const content = React.useMemo(
        () => getUserStatusContent(state?.userStatus),
        [state?.userStatus],
    )

    const handleLanguageChange = React.useCallback(() => {
        i18n.changeLanguage(i18n.getLocale() === 'tr' ? 'en' : 'tr')
    }, [])

    return (
        <div className="flex h-screen flex-col px-8 py-9">
            <div className="flex items-center justify-between gap-2">
                <img
                    src={state?.company?.logo}
                    alt={state?.company?.name}
                    className="h-12 w-auto"
                />
                <Button
                    variant="secondary"
                    size="medium"
                    className="px-6"
                    onClick={handleLanguageChange}>
                    {i18n.getLocale() === 'tr' ? 'EN' : 'TR'}
                </Button>
            </div>
            <InfoSheet
                icon="person-block"
                title={t(content.title)}
                description={t(content.description)}
                className="flex-grow"
                IconProps={{ size: 80, color: 'var(--content-ink)' }}
            />
        </div>
    )
}

export default UserFallback
